import curry from "../../../lib/core/functional/curry";
import noop from "../../../lib/core/functional/noop";

import loadPreactModule from "../../../utils/loadPreactModule";
import renderPreactWithProps from "../../../utils/renderPreactWithProps";
import callIfArgumentsPass from "../../../utils/callIfArgumentsPass";

import { uploadAvatar, uploadAvatarUrl } from "../../../transport/avatar";

import informer from "../../informer/loader";

import { getUserTransport, getSiteId } from "../_common";

function didLogoChanged(oldProfileSite, profileSite) {
    return profileSite.display_logo !== oldProfileSite.display_logo;
}

const informerUploadError = {
    title: "Error!",
    body: "An error has occured on uploading",
    possitiveAction: {
        text: "OK",
        callback: noop,
    },
};

export const renderEditLogo = curry(function renderEditLogo(
    moduleRenderer,
    context,
    userTransport,
    userProfile
) {
    function displayError() {
        render(userProfile.display_logo, false, null);
        informer(context, informerUploadError);
    }

    function onUploadDone(data) {
        render(userProfile.display_logo, false, data);
    }

    function saveChanges(data) {
        const { logo, image_id } = data;
        userTransport.sendChanges({ logo, storage: image_id });
    }

    const uploadFile = curry(function uploadFile(method, payload) {
        render(userProfile.display_logo, true, null);
        method(payload).then(onUploadDone).catch(displayError);
    });

    const onNewAvatarFile = uploadFile(uploadAvatar);
    const onNewAvatarUrl = uploadFile(uploadAvatarUrl);

    function render(logo, uploading, uploadData) {
        moduleRenderer({
            logo,
            uploading,
            uploadData,
            saveChanges,
            onNewAvatarFile,
            onNewAvatarUrl,
        });
    }

    render(userProfile.display_logo, false, null);
});

const onModule = curry(function onCurry(context, userTransport, element, [renderer, Module]) {
    const moduleRenderer = renderPreactWithProps(renderer, Module, element);
    element.innerHTML = "";
    userTransport.subscribeToChanges(
        callIfArgumentsPass(didLogoChanged, renderEditLogo(moduleRenderer, context, userTransport))
    );
});

const onUserTransport = curry(function onUserTransport(context, element, userTransport) {
    loadPreactModule("SiteEditLogo", context, {}, internalLoader)
        .then(onModule(context, userTransport, element))
        .catch(console.error);
});

const internalLoader = () => import("./module").then((module) => module.default);

export default function renderer(context, element) {
    const siteId = getSiteId(context, element);
    if (!siteId) {
        return;
    }

    getUserTransport(context, siteId).then(onUserTransport(context, element)).catch(console.error);
}
